import { BaseMapType, PlatformConfigs, SupportDeviceModel, SystemPlatform } from "@core/types";
import { MODEL_NAME_MAP, NONE_ROUTER_MODEL_NAME_MAP } from "./model-name-map";
import * as _ from 'lodash';

const MINUTES: number = 60000;
export const PLATFORM_CONFIGS: PlatformConfigs = {
    [SystemPlatform.STANDARD]: {
        defaultBaseMapType: BaseMapType.LIBERTY,
        baseMapOptions: [
            BaseMapType.BRIGHT,
            BaseMapType.BRIGHT_SMOOTH,
            BaseMapType.DARK,
            BaseMapType.LIBERTY,
            BaseMapType.SATELLITE
        ],
        simpleBaseMapOptions: [
            BaseMapType.LIBERTY,
            BaseMapType.SATELLITE
        ],
        geofenceEnable: true,
        menu_SUPPORT: true,
        menu_EMAILTEMPLATE: true,
        menu_AUDITLOGS: true,
        idleTimeoutRecovery: false,
        isReCaptchaEnable: true,
        isProfileAvatarSupported: true,
        encodeFileCheck: false,
        encodeAttribute: false,
        command_udpTest: false,
        command_backupSerialLog: false,
        command_capturePDNPacket: false,
        command_upgradeModule: false,
        device_webGui: true,
        device_ssh: true,
        config_gpsTracking: true,
        config_ttlHl: true,
        networkRemoteAccess: true,
        signalBreakThreshold: 60 * MINUTES, // 60 min
        firmwareUploadByAdmin: false,
        logFileManagement: false,
        moduleFileManagement: false,
        deviceModelList: _.omit(MODEL_NAME_MAP, Object.keys(NONE_ROUTER_MODEL_NAME_MAP)),
        publicFileSpace: true,
        scheduler_UpgradeModuleTask: false,
        esim: true,
        inSystemPurchase: false
    },
    [SystemPlatform.SCE]: {
        defaultBaseMapType: BaseMapType.OPEN_STREET_MAP,
        baseMapOptions: [
            BaseMapType.OPEN_STREET_MAP
        ],
        simpleBaseMapOptions: [],
        geofenceEnable: false,
        menu_SUPPORT: false,
        menu_EMAILTEMPLATE: false,
        menu_AUDITLOGS: false,
        idleTimeoutRecovery: true,
        isReCaptchaEnable: false,
        isProfileAvatarSupported: false,
        encodeFileCheck: true,
        encodeAttribute: true,
        command_udpTest: true,
        command_backupSerialLog: true,
        command_capturePDNPacket: true,
        command_upgradeModule: true,
        device_webGui: false,
        device_ssh: false,
        config_gpsTracking: false,
        config_ttlHl: false,
        networkRemoteAccess: false,
        signalBreakThreshold: 20 * MINUTES, // 20 min
        firmwareUploadByAdmin: true,
        logFileManagement: true,
        moduleFileManagement: true,
        deviceModelList: {
            [SupportDeviceModel.MX_220_UT_5G]: "MX-220-UT-5G"
        },
        publicFileSpace: false,
        scheduler_UpgradeModuleTask: true,
        esim: false,
        inSystemPurchase: false
    }
};